import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';

class MediaSlider {
    constructor(elem) {
        this.elem = elem;
        this.slider = this.elem.querySelector('.media-slider__container');
        this.sliderIconPrev = this.elem.querySelector('.swiper-button-prev--outer');
        this.sliderIconNext = this.elem.querySelector('.swiper-button-next--outer');
    }

    init() {
        const swiper = new Swiper(this.slider, {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 0,
            modules: [Navigation, Pagination],
            pagination: {
                el: '.swiper-pagination--outer',
                clickable: true,
            },
            navigation: {
                nextEl: this.sliderIconNext,
                prevEl: this.sliderIconPrev,
            },
            on: {
                afterInit: this.init_videos.bind(this),
                slideChangeTransitionStart: this.reset_youTube_iframes.bind(this)
            }
        });
    }

    init_videos() {
        this.imageVideoContainer = this.elem.querySelectorAll('.video-embed__video-image-container');
        if ( this.imageVideoContainer.length > 0 ) {
            for( var i = 0, ii = this.imageVideoContainer.length; i < ii; i++ ) {
                this.imageVideoContainer[i].ytID = this.imageVideoContainer[i].dataset.id;
                this.imageVideoContainer[i].addEventListener('click', this.ytImageClickFunc );
                this.imageVideoContainer[i].MediaSlider = this;
            }
        }
    }

    ytImageClickFunc() {
        var _mtm = _mtm || [];
        _mtm.push(
            {'event': 'Video', 'action': 'Start'}
        );
        this.MediaSlider.createYouTubeIframe(this);
    }

    createYouTubeIframe(el) {
        el.MediaSlider.reset_youTube_iframes();
        el.bak_inner_html = el.innerHTML;
        el.innerHTML = `<iframe title="yt-embed-${ el.ytID }" class="video-embed__video-iframe"
        width="833" height="468"
        src="https://www.youtube-nocookie.com/embed/${ el.ytID }?enablejsapi=1&autoplay=1"
        allow="autoplay" allowfullscreen=""></iframe>`;
    }

    reset_youTube_iframes() {
        if ( this.imageVideoContainer ) {
            if ( this.imageVideoContainer.length > 0 ) {
                for( var i = 0, ii = this.imageVideoContainer.length; i < ii; i++ ) {
                    if ( this.imageVideoContainer[i].bak_inner_html ) {
                        this.imageVideoContainer[i].innerHTML = this.imageVideoContainer[i].bak_inner_html;
                        this.imageVideoContainer[i].bak_inner_html = "";
                    }
                }
            }
        }
    }
}

export default MediaSlider;
